<sdc-bo-dialog
  [headerTitle]="
    isPrivateSellingEnabled
      ? 'Manage your private selling campaign'
      : 'Start a private selling campaign'
  "
  [styleClass]="['variant-prominent-title']">
  <div
    class="content-wrapper gap-12 flex flex-col justify-center items-center content-center text-center">
    <div class="bulk-edit-title flex flex-col text-start mb-0">
      <div>
        A private selling campaign allows you to
        <b> lock the events to anyone that is not included in the allowlist </b
        >. All events discoverable within the portal will require the user to
        login with their MLB credentials in order to buy tickets.
        <br />
        <br />

        To proceed with starting a private selling campaign, please provide the
        system with <b> at least one patron identificator </b> within the field
        below. <br />
      </div>

      <tagify
        name="tagify-element"
        class="tags-textarea"
        [formControl]="form"
        inputClass="w-full flex justify-start items-start"
        [settings]="settings"></tagify>

      <div class="flex justify-between mt-6">
        <div class="patron-ids-disclaimer flex flex-col justify-start">
          <div>
            * Any changes to the list will not be persisted until you hit the
            save button.
          </div>
          <div>* Clearing the list is irreversible.</div>
        </div>
        <div>
          <div class="flex gap-1">
            <button
              (click)="onSaveWhitelist()"
              [disabled]="!isSaveEnabled() || isLoading()"
              [class.off]="!isSaveEnabled() || isLoading()"
              type="submit"
              name="form"
              class="default-2 flex justify-center content-center">
              @if (isLoading()) {
                <span class="loader"></span>
              } @else {
                Save changes
              }
            </button>
            <button
              (click)="onClearWhitelist()"
              [class.off]="!form.value?.length"
              type="submit"
              name="form"
              class="default-2 red">
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss()">Close</sdc-button>
    @if (isPrivateSellingEnabled) {
      <sdc-button variant="destructive" (onClick)="onFinishCampaignConfirm()">
        Finish private selling
      </sdc-button>
    } @else {
      <sdc-button variant="primary" (onClick)="onStartCampaignConfirm()">
        Start private selling
      </sdc-button>
    }
  </ng-container>
</sdc-bo-dialog>
